import { Attrs, MinzeElement } from 'minze'
import { Locale } from '../../modules/locale'

Locale.getInstance().registerKeySet('fr', 'lvcEventCount', {
  label: 'Événements ({{count}})',
})
Locale.getInstance().registerKeySet('en', 'lvcEventCount', {
  label: 'Events ({{count}})',
})

export class LvcEventCount extends MinzeElement {
  attrs: Attrs = [['count', 0]]
  static observedAttributes = ['count']
  html = () => {
    return /*html*/ `
      <lvc-calendar-icon></lvc-calendar-icon>
      <div>${Locale.getKey('lvcEventCount.label', {
        count: this.count || 0,
      })}
      </div>
      `
  }
  css = () => /*css*/ `
    :host {
      font-size: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4px;
    }

  `
}
